// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Headlines-H2-module--cls1--3AOV1","cls2":"Headlines-H2-module--cls2--3DmOb Headlines-H2-module--cls1--3AOV1","small":"Headlines-H2-module--small--NS77u"};